import React from 'react';
import './AppVersionComponent.scss';
import packageJson from '../../../../package.json';

const AppVersionComponent: React.FC = () => {
  const version = packageJson.version; // This should match package.json version
  
  return (
    <div className="app-version">
      <span className="version-text">v{version}</span>
    </div>
  );
};

export default AppVersionComponent;
